import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Metas from 'components/Metas';
import PageContainer from "components/Page";
import PubSub from "services/PubSub/";
import { ecommerce, pages } from 'config/constants';
import LoginService from 'services/Login';
import CartService from 'services/Cart';
import style from './style.scss';//NOSONAR

const Home = (props) => {
    useEffect(() => {
        const loginShortcut = props.location && props.location.pathname === '/login';
        const registerShortcut = props.location && props.location.pathname === '/register';

        if(loginShortcut && !LoginService.isLogged()) {
            PubSub.dispatch('login_open');
        }

        if(registerShortcut) {
            PubSub.dispatch('register_open');
        }
        if(props.location){
            CartService.addProductsByUrl(props.location.search, props.history.replace);
        }
    }, []);

    return (
        <div className="home-page page">
            <Metas>
                <title>Supermercado | {ecommerce.metaTitle}</title>
            </Metas>
            <PageContainer pageId={pages.home} />
        </div>
    )
}

Home.propTypes = {
    location: PropTypes.object
};

export default Home;
